import React, {Fragment, useState} from "react";
///import "../../assets/css/course.css"
import Meeting_grupe_view from "./Meeting_grupe_view";
import {empty_bk} from "../../clientconfigwebapp";
const Meeting_view_single = (props) => {

return (
    <Fragment>
        {

            (() => {
                if(props.data_info_details.length==0) {
                    return (

<Fragment>
Loading
</Fragment>
                    )
                } else {


                    return (
                        <Meeting_grupe_view cource_id_get={props.cource_id_get} data_lessons={props.data_lessons} page_view={props.page_view} data_info_details={props.data_info_details} lesson_id={props.lesson_id}  />
                    )



                }
            })()



        }
    </Fragment>
)

  }
  
  export default Meeting_view_single;